import React from 'react'
import Modal from 'components/modal'
import 'less/inconsistent-meeting-information-modal.less'

const inconsistentMeetingInformationModal = props => {
    return (
        <Modal
            title={"Inconsistent Meeting Information Translations"}
            isOpen={props.isOpen}
            className="confirmation-modal inconsistent-meeting-information-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText="Confirm"
            cancelBtnText="Back"
            onCancel={props.onCancel}
            onSubmit={props.onSubmit}
            showCancelBtn={false}
        >
            <div className="inconsistent-meeting-information-modal-body">
                <div className="inconsistent-meeting-information-modal-text">
                    <p> {props.t('inconsistent.meeting.information.1')}</p>
                    <p> {props.t('inconsistent.meeting.information.2')}</p>
                </div>
            </div>
        </Modal>
    )
}
export default inconsistentMeetingInformationModal
